export interface PaginatedResponse<T> {
  data: T[]
  meta: {
    totalItems: number
    itemCount: number
    itemsPerPage: number
    totalPages: number
    currentPage: number
  }
}

// Names the saves of my own profile (PATCH /profile/me), so that the query
// reading it can tell when one is under way.
export const UPDATE_PROFILE_MUTATION_KEY = ['profile', 'me', 'update']
